// extracted by mini-css-extract-plugin
export var container = "_u7-0";
export var table = "_u7-2";
export var tableWrapper = "_u7-1";